const Footer = () =>{
    return(
        <footer className="specialCase">
            <p>Created with &#128153; @ Juno by Osman, Mohammed and Nicole. &copy; 2023</p>
        </footer>
    )
}

export default Footer;